import ApplicationController from './application_controller';

const COMPACT_ATTR_NAME = 'data-sidebar-compact';

export default class extends ApplicationController {
  static classes = ['toggle'];

  connect() {
    if (this.isTurboPreview) {
      this.renderFromCache();
    }
  }

  disconnect() {
    this.renderFromCache();
  }

  toggleNavSize() {
    this.element.classList.toggle(this.toggleClass);
    this.sidebarCache?.toggleAttribute(COMPACT_ATTR_NAME, !this.isExpanded);
    this.dispatch('toggle');
  }

  // Private

  renderFromCache() {
    if (!this.sidebarCache) return;
    this.element.classList.toggle(this.toggleClass, this.sidebarCache.hasAttribute(COMPACT_ATTR_NAME));
  }

  get isExpanded() {
    return !this.element.classList.contains(this.toggleClass);
  }

  get sidebarCache() {
    return document.getElementById('turbo-sidebar-cache');
  }
}
